import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ViewerTopRepliesLoadAction } from '../../domains/viewerTopReplies/actions.types';

import { ViewerTopRepliesLifecycle } from './types';

const initialState: ViewerTopRepliesLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<ViewerTopRepliesLifecycle, ViewerTopRepliesLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'VIEWER_TOP_REPLIES.LOAD_PENDING':
      return setPending();
    case 'VIEWER_TOP_REPLIES.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.viewerTopReplies);
    case 'VIEWER_TOP_REPLIES.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
